import { IMAncillaryContent, IMStandardsGroup } from '../types'
import { createSkillsList } from '../../nodeCreationHelpers'
import { snakeKabobToTitleCase } from '../../../utility'
import { ISkillsList } from '../../../components/ingestion/IngestedTree'

export function createIMSkillsList(
  title: string,
  standards: { title: string }[],
) {
  const cleanCode = (code: string) => {
    return code.replaceAll('-', '.')
  }
  return createSkillsList(
    title,
    standards.reduce<string[]>((acc, { title }) => {
      const cleaned = cleanCode(title)
      if (acc.includes(cleaned)) return acc
      return [...acc, cleaned]
    }, []),
  )
}

export function parseStandardsGroup(
  standards: IMStandardsGroup,
  ancillaryContent: IMAncillaryContent | undefined,
) {
  if (!standards) return []
  const extraAddressing = ancillaryContent?.math_practices ?? []
  const keys: (keyof IMStandardsGroup)[] = [
    'addressing',
    'building_on',
    'building_toward',
  ]

  return keys.reduce<ISkillsList[]>((acc, key) => {
    const extraStandards = key === 'addressing' ? extraAddressing : []
    const currentList = [...(standards[key] ?? []), ...extraStandards]
    if (currentList.length) {
      acc.push(createIMSkillsList(snakeKabobToTitleCase(key), currentList))
    }
    return acc
  }, [])
}
